import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from '../../elements';
import { AdminPage } from '../admin';
import { LoginPage, LogoutPage, SessionPage, UnauthorizedPage, LoginAsPage } from '../auth';
import { UserContext } from '../contexts';
import { DocumentationPage } from '../about';
import { GridPage, GridsPage } from '../grids';
import { HomePage } from '../home';
import {
  DuplicateRecordsReport,
  FieldRulesReport,
  PlmItemsJigsReport,
  ReportsPage,
  TaskCountsReport,
  TaskPerformancesReport,
} from '../reports';
import { TasksPage } from '../tasks';

export function Routes() {
  const { user } = useContext(UserContext);
  const isUser = () => user !== undefined;

  return (
    <Switch>
      <Route exact path="/session" component={SessionPage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/login-as/:userId" component={LoginAsPage} />
      <Route exact path="/logout" component={LogoutPage} />
      <Route exact path="/unauthorized" component={UnauthorizedPage} />
      <Route exact path="/documentation" component={DocumentationPage} />
      <Route exact path="/documentation/help" component={DocumentationPage} />
      <Route exact path="/documentation/release-notes" component={DocumentationPage} />
      <PrivateRoute exact path="/" component={HomePage} canOpen={isUser} />
      <PrivateRoute exact path="/grids" component={GridsPage} canOpen={isUser} />
      <PrivateRoute exact path="/grids/:id" component={GridPage} canOpen={isUser} />
      <PrivateRoute exact path="/tasks" component={TasksPage} canOpen={isUser} />
      <PrivateRoute exact path="/reports" component={ReportsPage} canOpen={isUser} />
      <PrivateRoute exact path="/reports/task-counts" component={TaskCountsReport} canOpen={isUser} />
      <PrivateRoute exact path="/reports/task-performances" component={TaskPerformancesReport} canOpen={isUser} />
      <PrivateRoute exact path="/reports/duplicate-records" component={DuplicateRecordsReport} canOpen={isUser} />
      <PrivateRoute exact path="/reports/plm-items-jigs" component={PlmItemsJigsReport} canOpen={isUser} />
      <PrivateRoute exact path="/reports/field-rules" component={FieldRulesReport} canOpen={isUser} />
      <PrivateRoute exact path="/admin" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/users" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/users/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/user-groups" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/user-groups/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles2" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles2/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/filters" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/filters/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/roles/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/delegations" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/grids" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/grids/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/integrations" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/integrations/:id" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/system-settings" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/caches" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/failed-queue-messages" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/backups" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/logs" component={AdminPage} canOpen={isUser} />
      <PrivateRoute exact path="/admin/dictionary" component={AdminPage} canOpen={isUser} />
    </Switch>
  );
}
